var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.639 13.37a1.593 1.593 0 00-1.008-1.009l-5.938-1.979 14.726-5.801-5.801 14.726-1.98-5.938zm7.958-8.967l-.094-.036.094.036zm-15.64 7.315c-1.24-.413-1.287-2.151-.07-2.63L19.084 3.1c1.138-.449 2.264.677 1.815 1.815l-5.987 15.197c-.479 1.217-2.217 1.17-2.63-.07l-2.066-6.2a.093.093 0 00-.06-.059l-6.199-2.066z",
    fill: "currentColor"
  })));
}
export default SvgLocation;